(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9396,9495],{

/***/ 77086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kz": function() { return /* binding */ googleLogout; },
/* harmony export */   "kZ": function() { return /* binding */ GoogleLogin; },
/* harmony export */   "rg": function() { return /* binding */ GoogleOAuthProvider; }
/* harmony export */ });
/* unused harmony exports hasGrantedAllScopesGoogle, hasGrantedAnyScopeGoogle, useGoogleLogin, useGoogleOAuth, useGoogleOneTapLogin */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
'use client'
;

function useLoadGsiScript(options = {}) {
    const { nonce, onScriptLoadSuccess, onScriptLoadError } = options;
    const [scriptLoadedSuccessfully, setScriptLoadedSuccessfully] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const onScriptLoadSuccessRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onScriptLoadSuccess);
    onScriptLoadSuccessRef.current = onScriptLoadSuccess;
    const onScriptLoadErrorRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onScriptLoadError);
    onScriptLoadErrorRef.current = onScriptLoadError;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const scriptTag = document.createElement('script');
        scriptTag.src = 'https://accounts.google.com/gsi/client';
        scriptTag.async = true;
        scriptTag.defer = true;
        scriptTag.nonce = nonce;
        scriptTag.onload = () => {
            var _a;
            setScriptLoadedSuccessfully(true);
            (_a = onScriptLoadSuccessRef.current) === null || _a === void 0 ? void 0 : _a.call(onScriptLoadSuccessRef);
        };
        scriptTag.onerror = () => {
            var _a;
            setScriptLoadedSuccessfully(false);
            (_a = onScriptLoadErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onScriptLoadErrorRef);
        };
        document.body.appendChild(scriptTag);
        return () => {
            document.body.removeChild(scriptTag);
        };
    }, [nonce]);
    return scriptLoadedSuccessfully;
}

const GoogleOAuthContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
function GoogleOAuthProvider({ clientId, nonce, onScriptLoadSuccess, onScriptLoadError, children, }) {
    const scriptLoadedSuccessfully = useLoadGsiScript({
        nonce,
        onScriptLoadSuccess,
        onScriptLoadError,
    });
    const contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({
        clientId,
        scriptLoadedSuccessfully,
    }), [clientId, scriptLoadedSuccessfully]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(GoogleOAuthContext.Provider, { value: contextValue }, children));
}
function useGoogleOAuth() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(GoogleOAuthContext);
    if (!context) {
        throw new Error('Google OAuth components must be used within GoogleOAuthProvider');
    }
    return context;
}

function extractClientId(credentialResponse) {
    var _a;
    const clientId = (_a = credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.clientId) !== null && _a !== void 0 ? _a : credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.client_id;
    return clientId;
}

const containerHeightMap = { large: 40, medium: 32, small: 20 };
function GoogleLogin({ onSuccess, onError, useOneTap, promptMomentNotification, type = 'standard', theme = 'outline', size = 'large', text, shape, logo_alignment, width, locale, click_listener, containerProps, ...props }) {
    const btnContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const { clientId, scriptLoadedSuccessfully } = useGoogleOAuth();
    const onSuccessRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!scriptLoadedSuccessfully)
            return;
        (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.initialize({
            client_id: clientId,
            callback: (credentialResponse) => {
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) {
                    return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                }
                const { credential, select_by } = credentialResponse;
                onSuccessRef.current({
                    credential,
                    clientId: extractClientId(credentialResponse),
                    select_by,
                });
            },
            ...props,
        });
        (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 ? void 0 : _f.renderButton(btnContainerRef.current, {
            type,
            theme,
            size,
            text,
            shape,
            logo_alignment,
            width,
            locale,
            click_listener,
        });
        if (useOneTap)
            (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 ? void 0 : _j.prompt(promptMomentNotificationRef.current);
        return () => {
            var _a, _b, _c;
            if (useOneTap)
                (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.cancel();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientId,
        scriptLoadedSuccessfully,
        useOneTap,
        type,
        theme,
        size,
        text,
        shape,
        logo_alignment,
        width,
        locale,
    ]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { ...containerProps, ref: btnContainerRef, style: { height: containerHeightMap[size], ...containerProps === null || containerProps === void 0 ? void 0 : containerProps.style } }));
}

function googleLogout() {
    var _a, _b, _c;
    (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.disableAutoSelect();
}

/* eslint-disable import/export */
function useGoogleLogin({ flow = 'implicit', scope = '', onSuccess, onError, onNonOAuthError, overrideScope, state, ...props }) {
    const { clientId, scriptLoadedSuccessfully } = useGoogleOAuth();
    const clientRef = useRef();
    const onSuccessRef = useRef(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = useRef(onError);
    onErrorRef.current = onError;
    const onNonOAuthErrorRef = useRef(onNonOAuthError);
    onNonOAuthErrorRef.current = onNonOAuthError;
    useEffect(() => {
        var _a, _b;
        if (!scriptLoadedSuccessfully)
            return;
        const clientMethod = flow === 'implicit' ? 'initTokenClient' : 'initCodeClient';
        const client = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2[clientMethod]({
            client_id: clientId,
            scope: overrideScope ? scope : `openid profile email ${scope}`,
            callback: (response) => {
                var _a, _b;
                if (response.error)
                    return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, response);
                (_b = onSuccessRef.current) === null || _b === void 0 ? void 0 : _b.call(onSuccessRef, response);
            },
            error_callback: (nonOAuthError) => {
                var _a;
                (_a = onNonOAuthErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onNonOAuthErrorRef, nonOAuthError);
            },
            state,
            ...props,
        });
        clientRef.current = client;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientId, scriptLoadedSuccessfully, flow, scope, state]);
    const loginImplicitFlow = useCallback((overrideConfig) => { var _a; return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestAccessToken(overrideConfig); }, []);
    const loginAuthCodeFlow = useCallback(() => { var _a; return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestCode(); }, []);
    return flow === 'implicit' ? loginImplicitFlow : loginAuthCodeFlow;
}

function useGoogleOneTapLogin({ onSuccess, onError, promptMomentNotification, cancel_on_tap_outside, prompt_parent_id, state_cookie_domain, hosted_domain, use_fedcm_for_prompt = false, use_fedcm_for_button = false, disabled, auto_select, }) {
    const { clientId, scriptLoadedSuccessfully } = useGoogleOAuth();
    const onSuccessRef = useRef(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = useRef(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = useRef(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!scriptLoadedSuccessfully)
            return;
        if (disabled) {
            (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.cancel();
            return;
        }
        (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 ? void 0 : _f.initialize({
            client_id: clientId,
            callback: (credentialResponse) => {
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) {
                    return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                }
                const { credential, select_by } = credentialResponse;
                onSuccessRef.current({
                    credential,
                    clientId: extractClientId(credentialResponse),
                    select_by,
                });
            },
            hosted_domain,
            cancel_on_tap_outside,
            prompt_parent_id,
            state_cookie_domain,
            use_fedcm_for_prompt,
            use_fedcm_for_button,
            auto_select,
        });
        (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 ? void 0 : _j.prompt(promptMomentNotificationRef.current);
        return () => {
            var _a, _b, _c;
            (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.cancel();
        };
    }, [
        clientId,
        scriptLoadedSuccessfully,
        cancel_on_tap_outside,
        prompt_parent_id,
        state_cookie_domain,
        hosted_domain,
        use_fedcm_for_prompt,
        use_fedcm_for_button,
        disabled,
        auto_select,
    ]);
}

/**
 * Checks if the user granted all the specified scope or scopes
 * @returns True if all the scopes are granted
 */
function hasGrantedAllScopesGoogle(tokenResponse, firstScope, ...restScopes) {
    var _a, _b, _c;
    if (!(window === null || window === void 0 ? void 0 : window.google))
        return false;
    return (((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : _c.hasGrantedAllScopes(tokenResponse, firstScope, ...restScopes)) || false);
}

/**
 * Checks if the user granted any of the specified scope or scopes.
 * @returns True if any of the scopes are granted
 */
function hasGrantedAnyScopeGoogle(tokenResponse, firstScope, ...restScopes) {
    var _a, _b, _c;
    if (!(window === null || window === void 0 ? void 0 : window.google))
        return false;
    return (((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : _c.hasGrantedAnyScope(tokenResponse, firstScope, ...restScopes)) || false);
}




/***/ }),

/***/ 8734:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(3294);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PageWrapper_PageWrapper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/Header/Header.tsx + 1 modules
var Header = __webpack_require__(15304);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx
var Footer = __webpack_require__(83767);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./components/PageWrapper/PageWrapper.module.scss
var PageWrapper_module = __webpack_require__(70930);
var PageWrapper_module_default = /*#__PURE__*/__webpack_require__.n(PageWrapper_module);
;// CONCATENATED MODULE: ./components/PageWrapper/PageWrapper.tsx






var PageWrapper = function(param) {
    var dateText = param.dateText, titleText = param.titleText, introText = param.introText, _headerContainerClass = param.headerContainerClass, headerContainerClass = _headerContainerClass === void 0 ? "" : _headerContainerClass, _headerSectionClass = param.headerSectionClass, headerSectionClass = _headerSectionClass === void 0 ? "" : _headerSectionClass, _contentContainerClass = param.contentContainerClass, contentContainerClass = _contentContainerClass === void 0 ? "" : _contentContainerClass, children = param.children, aboutData = param.aboutData, additionalHeaderContent = param.additionalHeaderContent, additionalContent = param.additionalContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (PageWrapper_module_default()).pageWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((PageWrapper_module_default()).headerContainer, " ").concat((PageWrapper_module_default()).pattern, " ").concat(headerContainerClass),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "".concat((PageWrapper_module_default()).headerSection, " ").concat(headerSectionClass),
                        children: [
                            !!dateText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).dateContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "text-md",
                                    color: "secondary",
                                    weight: "normal",
                                    className: (PageWrapper_module_default()).dateText,
                                    children: dateText
                                })
                            }),
                            !!titleText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).titleContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "display-lg",
                                    as: "h1",
                                    color: "primary",
                                    weight: "bold",
                                    className: (PageWrapper_module_default()).mainTitle,
                                    children: titleText
                                })
                            }),
                            !!introText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).introContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "text-xl",
                                    color: "secondary",
                                    weight: "normal",
                                    className: (PageWrapper_module_default()).introText,
                                    children: introText
                                })
                            }),
                            additionalHeaderContent
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "".concat((PageWrapper_module_default()).contentContainer, " ").concat(contentContainerClass),
                    children: children
                }),
                additionalContent,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {
                    aboutData: aboutData
                })
            ]
        })
    });
};
/* harmony default export */ var PageWrapper_PageWrapper = (PageWrapper);

;// CONCATENATED MODULE: ./components/PageWrapper/index.ts



/***/ }),

/***/ 3294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _components_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39181);
/* harmony import */ var _privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41046);
/* harmony import */ var _privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_PageWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96424);
/* harmony import */ var _components_SEO__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38743);






var PrivacyPolicy = function(param) {
    var aboutData = param.aboutData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SEO__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: "Privacy Policy",
                description: "Read EPEN Ltd. Privacy Policy to understand how we collect, use, and protect your personal information. Your privacy matters to us. Learn more!",
                keywords: "privacy policy, data protection, epen"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageWrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                dateText: "Current as of 20 Jan 2025",
                titleText: "Privacy Policy",
                introText: "Your privacy is important to us at Untitled. We respect your privacy regarding any information we may collect from you across our website.",
                title: "Privacy Policy",
                headerContainerClass: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().headerContainer),
                aboutData: aboutData,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().contentSection),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            children: "Mi tincidunt elit, id quisque ligula ac diam, amet. Vel etiam suspendisse morbi eleifend faucibus eget vestibulum felis. Dictum quis montes, sit sit. Tellus aliquam enim urna, etiam. Mauris posuere vulputate arcu amet, vitae nisi, tellus tincidunt. At feugiat sapien varius id."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            children: "Eget quis mi enim, leo lacinia pharetra, semper. Eget in volutpat mollis at volutpat lectus velit, sed auctor. Porttitor fames arcu quis fusce augue enim. Quis at habitant diam at. Suscipit tristique risus, at donec. In turpis vel et quam imperdiet. Ipsum molestie aliquet sodales id est ac volutpat."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subsection),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                variant: "display-xs",
                                color: "primary",
                                weight: "bold",
                                className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subheading),
                                children: "What information do we collect?"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            children: "Dolor enim eu tortor urna sed duis nulla. Aliquam vestibulum, nulla odio nisl vitae. In aliquet pellentesque aenean hac vestibulum turpis mi bibendum diam. Tempor integer aliquam in vitae malesuada fringilla."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            children: "Elit nisi in eleifend sed nisi. Pulvinar at orci, proin imperdiet commodo consectetur convallis risus. Sed condimentum enim dignissim adipiscing faucibus consequat, urna. Viverra purus et erat auctor aliquam. Risus, volutpat vulputate posuere purus sit congue convallis aliquet. Arcu id augue ut feugiat donec porttitor neque. Mauris, neque ultricies eu vestibulum, bibendum quam lorem id. Dolor lacus, eget nunc lectus in tellus, pharetra, porttitor."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            children: "Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris id. Non pellentesque congue eget consectetur turpis. Sapien, dictum molestie sem tempor. Diam elit, orci, tincidunt aenean tempus. Quis velit eget ut tortor tellus. Sed vel, congue felis elit erat nam nibh orci."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subsection),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                variant: "display-xs",
                                color: "primary",
                                weight: "bold",
                                className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subheading),
                                children: "How do we use your information?"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            children: "Dolor enim eu tortor urna sed duis nulla. Aliquam vestibulum, nulla odio nisl vitae. In aliquet pellentesque aenean hac vestibulum turpis mi bibendum diam. Tempor integer aliquam in vitae malesuada fringilla."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            children: "Elit nisi in eleifend sed nisi. Pulvinar at orci, proin imperdiet commodo consectetur convallis risus. Sed condimentum enim dignissim adipiscing faucibus consequat, urna. Viverra purus et erat auctor aliquam. Risus, volutpat vulputate posuere purus sit congue convallis aliquet. Arcu id augue ut feugiat donec porttitor neque. Mauris, neque ultricies eu vestibulum, bibendum quam lorem id. Dolor lacus, eget nunc lectus in tellus, pharetra, porttitor."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            children: "Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris id. Non pellentesque congue eget consectetur turpis. Sapien, dictum molestie sem tempor. Diam elit, orci, tincidunt aenean tempus. Quis velit eget ut tortor tellus. Sed vel, congue felis elit erat nam nibh orci."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subsection),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                variant: "display-xs",
                                color: "primary",
                                weight: "bold",
                                className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subheading),
                                children: "Do we use cookies and other tracking technologies?"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            children: "Pharetra morbi libero id aliquam elit massa integer tellus. Quis felis aliquam ullamcorper porttitor. Pulvinar ullamcorper sit dictumst ut eget a, elementum eu. Maecenas est morbi mattis id in ac pellentesque ac."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subsection),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                variant: "display-xs",
                                color: "primary",
                                weight: "bold",
                                className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subheading),
                                children: "How long do we keep your information?"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            children: "Pharetra morbi libero id aliquam elit massa integer tellus. Quis felis aliquam ullamcorper porttitor. Pulvinar ullamcorper sit dictumst ut eget a, elementum eu. Maecenas est morbi mattis id in ac pellentesque ac."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subsection),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                variant: "display-xs",
                                color: "primary",
                                weight: "bold",
                                className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subheading),
                                children: "How do we keep your information safe?"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            children: "Pharetra morbi libero id aliquam elit massa integer tellus. Quis felis aliquam ullamcorper porttitor. Pulvinar ullamcorper sit dictumst ut eget a, elementum eu. Maecenas est morbi mattis id in ac pellentesque ac."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subsection),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                variant: "display-xs",
                                color: "primary",
                                weight: "bold",
                                className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subheading),
                                children: "What are your privacy rights?"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            children: "Pharetra morbi libero id aliquam elit massa integer tellus. Quis felis aliquam ullamcorper porttitor. Pulvinar ullamcorper sit dictumst ut eget a, elementum eu. Maecenas est morbi mattis id in ac pellentesque ac."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subsection),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                variant: "display-xs",
                                color: "primary",
                                weight: "bold",
                                className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subheading),
                                children: "How can you contact us about this policy?"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            children: "Sagittis et eu at elementum, quis in. Proin praesent volutpat egestas sociis sit lorem nunc nunc sit. Eget diam curabitur mi ac. Auctor rutrum lacus malesuada massa ornare et. Vulputate consectetur ac ultrices at diam dui eget fringilla tincidunt. Arcu sit dignissim massa erat cursus vulputate gravida id. Sed quis auctor vulputate hac elementum gravida cursus dis."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            style: {
                                marginLeft: "16px"
                            },
                            children: "1. Lectus id duis vitae porttitor enim gravida morbi."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            style: {
                                marginLeft: "16px"
                            },
                            children: "2. Eu turpis posuere semper feugiat volutpat elit, ultrices suspendisse. Auctor vel in vitae placerat."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                            variant: "text-lg",
                            color: "secondary",
                            weight: "normal",
                            className: (_privacy_policy_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
                            style: {
                                marginLeft: "16px"
                            },
                            children: "3. Suspendisse maecenas ac donec scelerisque diam sed est duis purus."
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PrivacyPolicy);


/***/ }),

/***/ 70930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"PageWrapper_pageWrapper__MAYBo","pattern":"PageWrapper_pattern__3xQmd","headerContainer":"PageWrapper_headerContainer__DAIQD","headerSection":"PageWrapper_headerSection__BJHBX","dateContainer":"PageWrapper_dateContainer__OCDfk","dateText":"PageWrapper_dateText__ErZHL","titleContainer":"PageWrapper_titleContainer__V5tyY","mainTitle":"PageWrapper_mainTitle__yIEnc","introText":"PageWrapper_introText__ZUDXH","contentContainer":"PageWrapper_contentContainer__0fKHq"};

/***/ }),

/***/ 41046:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"privacy-policy_headerContainer__FCkmj","contentSection":"privacy-policy_contentSection__o03Ea","paragraph":"privacy-policy_paragraph__ewRWO","subsection":"privacy-policy_subsection__W90zp","subheading":"privacy-policy_subheading__V6P6Q"};

/***/ }),

/***/ 97508:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 31922:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Skeleton; },
/* harmony export */   "y": function() { return /* binding */ SkeletonTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
'use client';


/**
 * @internal
 */
const SkeletonThemeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

/* eslint-disable react/no-array-index-key */
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, customHighlightBackground, }) {
    const style = {};
    if (direction === 'rtl')
        style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number')
        style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation)
        style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number')
        style.width = width;
    if (typeof height === 'string' || typeof height === 'number')
        style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number')
        style.borderRadius = borderRadius;
    if (circle)
        style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined')
        style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined')
        style['--highlight-color'] = highlightColor;
    if (typeof customHighlightBackground === 'string')
        style['--custom-highlight-background'] = customHighlightBackground;
    return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = react__WEBPACK_IMPORTED_MODULE_0__.useContext(SkeletonThemeContext);
    const propsStyleOptions = { ...originalPropsStyleOptions };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
        if (typeof value === 'undefined') {
            delete propsStyleOptions[key];
        }
    }
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle,
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...styleOptionsToCssProperties(styleOptions),
    };
    let className = 'react-loading-skeleton';
    if (customClassName)
        className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for (let i = 0; i < countCeil; i++) {
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number'
                ? width * fractionalPart
                : `calc(${width} * ${fractionalPart})`;
            thisStyle = { ...thisStyle, width: fractionalWidth };
        }
        const skeletonSpan = (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: className, style: thisStyle, key: i }, "\u200C"));
        if (inline) {
            elements.push(skeletonSpan);
        }
        else {
            // Without the <br />, the skeleton lines will all run together if
            // `width` is specified
            elements.push(react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: i },
                skeletonSpan,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null)));
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper
        ? elements.map((el, i) => react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, { key: i }, el))
        : elements));
}

function SkeletonTheme({ children, ...styleOptions }) {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(SkeletonThemeContext.Provider, { value: styleOptions }, children));
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3977,6538,6607,8030,2033,5304,6309,9774,2888,179], function() { return __webpack_exec__(8734); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);